import { createContext, useContext, useMemo, useState } from "react";
import { googleLoginUser, loginUser, registerUser } from "../services/auth.service";
import { dataHelper } from "../helpers";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(dataHelper.getToken());
  const [user, setUser] = useState(dataHelper.getUser());

  const login = async (payload) => {
    const data = await loginUser(payload);
    setToken(data.token);
    setUser(data.user);
    dataHelper.setSession(data.token, data.user);
  };

  const register = async (payload) => {
    const data = await registerUser(payload);
    setToken(data.token);
    setUser(data.user);
    dataHelper.setSession(data.token, data.user);
  };

  const logout = () => {
    setToken("");
    setUser(null);
    dataHelper.clearSession();
  };

  const loginWithGoogle = async (idToken) => {
    const data = await googleLoginUser(idToken);
    setToken(data.token);
    setUser(data.user);
    dataHelper.setSession(data.token, data.user);
  };

  const value = useMemo(
    () => ({ token, user, login, register, logout, loginWithGoogle }),
    [token, user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
